<script>
import simplebar from "simplebar-vue";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import MultiSelect from "vue-multiselect";
import { Mentionable } from "vue-mention";
import VueDropify from "vue-dropify";

// Custom Components
import PageHeader from "@/components/page-header";
import InboxService from "@/helpers/APIService/inbox.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import Email from "@/components/messaging/email.vue";
import smsGuestProfile from "@/components/messaging/smsGuestProfile.vue";
import GuestRegister from "@/components/messaging/guestMessage.vue";
import LobbyRegister from "@/components/messaging/lobbyGC.vue";
import TagManager from "@/components/messaging/tagAddUpdate.vue";
import Middleware from "@/helpers/middlewares";

/* Chat Component */
export default {
  page: {
    title: "Chat",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    simplebar,
    MultiSelect,
    Mentionable,
    Email,
    smsGuestProfile,
    GuestRegister,
    LobbyRegister,
    TagManager,
    VueDropify,
  },
  data() {
    return {
      title: "Inbox",
      tagsOptions: [],
      sideBar: [
        { name: "Inbox", icon: "mdi mdi-email-outline" },
        { name: "Mentions", icon: "mdi mdi-star-outline" },
        { name: "All", icon: "mdi mdi-diamond-stone" },
        // { name: "Assigned", icon: "mdi mdi-file-outline" },
        // { name: "Unassigned", icon: "mdi mdi-email-check-outline" },
        { name: "Following", icon: "mdi mdi-star-outline" },
        // { name: "Trash", icon: "mdi mdi-trash-can-outline" },
      ],
      // "INQUIRY",
      // "PRE CHECK-IN",
      // "IN-House",
      // "Arrival",
      // "CHECK OUT",
      // "VIP",
      // "GLITCH",
      // "REQUEST",
      emojis: ["🙂", "👍", "🥳", "❤️", "😴", "🙁"],
      isGetUserLoading: false,
      users: [],
      mentionUsers: [],
      msgTagUsers: [],
      tagUsers: [],
      chatData: [],
      groupChatData: [],
      allChatData: [],
      matchUser: "",
      activeUser: null,
      chatMessagesData: [],
      repeatedData: [],
      submittedProfile: false,
      sendingMessage: false,
      profile: {
        name: null,
        tags: [],
        mentionedUsers: [],
        first_name: null,
        last_name: null,
      },
      isUpdateProfileBtnLoading: false,
      submitted: false,
      form: {
        message: "",
      },
      isShowAllUsers: false,
      input: "",
      emoSearch: "",
      showEmoji: false,
      reactionOnMessage: "",
      optionsArray1: [],
      gettingMessages: false,
      selectedMessage: null,
      textMessageIso: null,
      profileAttachments: null,
      imgURL: null,
      attachments: [],
      attachmentsToShow: [],
      text: "",
      isDisplayChat: false,
      submittedLobbyChat: false,
      doScroll: true,
      smsType: "sms",
      counter: 0,
      isLobbyGroup: false,
      showingAll: false,
      selectedName: "Inbox",
      lastDisplayedDate: null,
      textAreaMax: 2500,
      previewImageInModel: [],
      displayProfile: true,
      displayTags: [],
      messageNotification: null,
      isShowGuestDetails: false,
      showEmptyNameError: false,
    };
  },
  computed: {
    ...authComputed,
    emailProps() {
      return {
        chatData: this.chatData,
        chatUsers: this.mentionUsers,
        chatTagOptions: this.tagsOptions,
        selectedName: this.selectedName,
      };
    },
  },
  validations: {
    form: {
      message: { required },
    },
  },
  beforeMount() {
    this.getTags();
  },
  mounted() {
    this.handleScrollOnMount();
    this.getAllUsers();
    this.getGroupChatUserList();
    this.getCommonLobbyGC();
    this.showAll(this.selectedName);
    this.$root.$on("onEmailSelect", ({ email, isRead }) => {
      this.isDisplayChat = isRead;
      this.activeUser = email;
      this.chatUsername(this.activeUser);
    });
    this.$root.$on("messageData", (data) => {
      this.messageNotification = data;
      const { command, message, sender } = this.messageNotification;
      if (command && message && sender) {
        this.mentionUsers.map((item) => {
          for (let index = 0; index < message.length; index++) {
            const element = message[index];
            if (item.id == element.id) {
              item.status = element.currant_status;
            }
          }
        });
      } else {
        if (data.action == "create" && data.command == "user_message") {
          if (this.activeUser != null) {
            this.doScroll = true;
            this.getRepeatedData(this.activeUser);
          } else {
            this.getRepeatedUsers();
            this.getRepeatedUsers();
          }
        } else if (
          (data.action == "create" || data.action == "update") &&
          data.command == "inbox_message"
        ) {
          if (
            this.activeUser != null &&
            this.activeUser.id !== data.payload.msg_sent_by.id
          ) {
            this.doScroll = true;
            this.getRepeatedData(this.activeUser);
          } else {
            if (data.payload.inbox_group.group_type == "common_lobby") {
              this.getRepeatedLobbyGC();
            } else if (data.payload.inbox_group.group_type == "guest") {
              this.getRepeatedGuestGC();
            }
          }
        }
      }
    });
    this.$root.$on("relaodPage", () => {
      this.counter = 0;
      this.getGroupChatUserList();
      this.getCommonLobbyGC();
    });
    this.$root.$on("cancelAddition", () => {
      this.cancelAdding();
    });
    this.$root.$on("showBookingDetail", (data) => {
      this.isShowGuestDetails = data;
    });
    this.showingAll = false;
  },
  beforeDestroy() {
    this.activeUser = null;
    localStorage.removeItem("thisChatData");
  },
  methods: {
    applyMen(event) {
      if (!this.msgTagUsers.includes(event.id)) {
        this.msgTagUsers.push(event.id);
      }
    },
    // Get all tags
    async getTags() {
      this.tagsOptions = [];
      await InboxService.getTagsOfGroup()
        .then((response) => {
          response.map((resp) => {
            const data = {
              name: resp.name,
              value: resp.id,
              color: resp.color,
              is_active: resp.is_active,
            };
            this.tagsOptions.push(data);
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
      localStorage.setItem("thisChatData", JSON.stringify(this.tagsOptions));
      this.$root.$emit("chatTagOptions", this.tagsOptions);
    },
    // Method is used to handle scroll on component mount
    handleScrollOnMount() {
      if (this.activeUser != null) {
        var container1 = document.querySelector(
          "#chat-list .simplebar-content-wrapper"
        );
        container1.scrollTo({ top: 500, behavior: "smooth" });

        var container2 = document.querySelector(
          "#containerElement .simplebar-content-wrapper"
        );
        container2.scrollTo({ top: 500, behavior: "smooth" });
      }
    },
    // Method is used to get all users
    async getAllUsers() {
      try {
        this.isGetUserLoading = true;
        this.users = [];
        const response = await InboxService.getAllSMSUsers();
        if (response) {
          response.map((user) => {
            this.mentionUsers.push({
              ...user,
              value: user.first_name,
              personal: true,
              created_at: moment().format("YYYY-MM-DD"),
              name: user.first_name + " " + user.last_name,
              image: user.profile_picture,
              last_inbox_message: user.last_chat_message,
            });
          });
          this.isGetUserLoading = false;
          this.$root.$emit("chatUsers", this.mentionUsers);
        }
      } catch (error) {
        this.isGetUserLoading = false;
        errorHandler(error);
      }
    },
    async getRepeatedUsers() {
      const response = await InboxService.getAllSMSUsers();
      if (response) {
        response.map((user) => {
          if (user.last_chat_message != null) {
            for (let index = 0; index < this.mentionUsers.length; index++) {
              const element = this.mentionUsers[index];
              if (element.id == user.id) {
                element.last_inbox_message = user.last_chat_message;
                element.unread_message = user.unread_message;
              }
            }
          }
        });
      }
    },
    // Method is used to get group chat users list
    async getGroupChatUserList() {
      this.chatData = [];
      try {
        const response = await InboxService.getInboxGroups();
        if (response.results.length !== 0) {
          response.results.map((item) => {
            let name =
              item.inbox_user != null &&
              item.inbox_user.first_name != null &&
              item.inbox_user.last_name != null
                ? item.inbox_user.first_name + " " + item.inbox_user.last_name
                : item.group_name != null
                ? item.group_name
                : item.group_send_number;
            let image = item.group_avtar
              ? item.group_avtar
              : item.inbox_user !== null
              ? item.inbox_user.profile_picture
                ? item.inbox_user.profile_picture
                : null
              : null;
            const time = this.convertDateOrTime(item.updated_at, "HH:mm A");
            this.chatData.push({ ...item, name, image, time });
          });
          this.chatData.map((item) => {
            if (item.unread_message != 0) {
              this.counter += 1;
            }
          });
        }
        this.showAll(this.selectedName);
      } catch (error) {
        errorHandler(error);
      }
    },
    async getCommonLobbyGC() {
      this.groupChatData = [];
      try {
        const response = await InboxService.getInboxGroups(
          "?group_type=common_lobby"
        );
        if (response.results.length !== 0) {
          response.results.map((item) => {
            let name =
              item.group_name != null
                ? item.group_name
                : this.inbox_user != null
                ? this.inbox_user.first_name && this.inbox_user.last_name
                  ? this.inbox_user.first_name + " " + this.inbox_user.last_name
                  : this.group_send_number
                : "group";
            let image =
              item.inbox_user !== null
                ? item.inbox_user.profile_picture
                  ? item.inbox_user.profile_picture
                  : item.inbox_user.group_avtar
                  ? item.inbox_user.group_avtar
                  : null
                : null;
            const time = this.convertDateOrTime(item.updated_at, "HH:mm A");
            this.groupChatData.push({ ...item, name, image, time });
          });
          this.groupChatData.map((item) => {
            if (item.unread_message != 0) {
              this.counter += 1;
            }
          });
        }
        this.showAll(this.selectedName);
      } catch (error) {
        errorHandler(error);
      }
    },
    async getRepeatedLobbyGC() {
      const response = await InboxService.getInboxGroups(
        "?group_type=common_lobby"
      );
      if (response) {
        response.results.map((GCData) => {
          if (GCData.last_inbox_message != null) {
            for (let index = 0; index < this.groupChatData.length; index++) {
              const element = this.groupChatData[index];
              if (element.id == GCData.id) {
                element.last_inbox_message = GCData.last_inbox_message;
                element.unread_message = GCData.unread_message;
              }
            }
          }
        });
      }
    },
    async getRepeatedGuestGC() {
      const response = await InboxService.getInboxGroups();
      if (response) {
        response.results.map((guestData) => {
          if (guestData.last_inbox_message != null) {
            for (let index = 0; index < this.chatData.length; index++) {
              const element = this.chatData[index];
              if (element.id == guestData.id) {
                element.last_inbox_message = guestData.last_inbox_message;
                element.unread_message = guestData.unread_message;
                element.group_tags = guestData.group_tags;
                element.group_name =
                  guestData && guestData.group_name != null
                    ? guestData.group_name
                    : element.group_name;
              }
            }
          }
        });
      }
    },
    // For new conversation
    newConvo(data) {
      this.textMessageIso = this.hotel.phone_number_iso
        ? this.hotel.phone_number_iso
        : "us";
      this.isLobbyGroup = data;
      this.$bvModal.show("add-chat");
    },
    // Method is used to handle single user
    async chatUsername(data) {
      this.$root.$emit("showDetail", false);
      this.selectedMessage = null;
      this.form.message = "";
      this.attachmentsToShow = [];
      this.isShowGuestDetails = false;
      this.smsType = "sms";
      this.gettingMessages = true;
      this.activeUser = data;
      if (this.activeUser && this.activeUser.group_followers) {
        this.profile.mentionedUsers = [];
        this.activeUser.group_followers.map((item) => {
          if (item != this.user.user.id) {
            const responseData = this.mentionUsers.find(
              (mention) => mention.id == item
            );
            if (responseData !== undefined) {
              this.profile.mentionedUsers.push(responseData);
            }
          }
        });
      }
      try {
        this.chatMessagesData = [];
        let response = [];
        if (data.personal) {
          response = await InboxService.getPersonalChatMessages(data.id);
        } else {
          response = await InboxService.getInboxChatGroup(data.id);
        }
        if (response.results.length !== 0) {
          response.results.map((item) => {
            this.chatMessagesData.unshift({
              allData: item,
              message: item.msg_content,
              time: this.convertDateOrTime(item.created_at, "HH:mm A"),
              reactions: item.msg_read_user ? item.msg_read_user : null,
              align:
                item.msg_sent_by !== null
                  ? this.user.user.id == item.msg_sent_by.id ||
                    this.user.user.id == item.msg_sent_by
                    ? "right"
                    : ""
                  : "",
              sms_color: item.msg_sent_by == null ? "yellow" : "",
            });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
      this.gettingMessages = false;
      this.attachments = [];
      this.handleScroll();
      if (data.personal) {
        await this.getRepeatedUsers();
      } else {
        this.getRepeatedLobbyGC();
        this.getRepeatedGuestGC();
      }
    },
    // To get and replace data
    async getRepeatedData(data) {
      this.activeUser.unread_message = 0;
      this.activeUser = data;
      if (this.$route.path == "/inbox" && this.activeUser != null) {
        this.repeatedData = [];
        let response = [];
        try {
          if (data.personal) {
            response = await InboxService.getPersonalChatMessages(data.id);
          } else {
            response = await InboxService.getInboxChatGroup(data.id);
          }
          if (response.results.length !== 0) {
            response.results.map((item) => {
              this.repeatedData.unshift({
                allData: item,
                message: item.msg_content,
                time: this.convertDateOrTime(item.created_at, "HH:mm A"),
                reactions: item.msg_read_user ? item.msg_read_user : null,
                align:
                  item.msg_sent_by !== null
                    ? this.user.user.id == item.msg_sent_by.id ||
                      this.user.user.id == item.msg_sent_by
                      ? "right"
                      : ""
                    : "",
                sms_color: item.msg_sent_by == null ? "yellow" : "",
              });
            });
            this.chatMessagesData = [];
            this.chatMessagesData = this.repeatedData;
            this.allChatData.map((item) => {
              if (item.id == this.activeUser.id) {
                item.last_inbox_message =
                  this.chatMessagesData[
                    this.chatMessagesData.length - 1
                  ].allData;
              }
            });
          }
          if (this.doScroll == true) {
            this.handleScroll();
            this.doScroll = false;
          }
        } catch (error) {
          errorHandler(error);
        }
      }
    },
    // Method is used to update profile
    updateProfile() {
      this.$bvModal.show("update-profile");
      this.profile.mentionedUsers = [];
      this.profile.name =
        this.activeUser.group_name != null ? this.activeUser.group_name : "";
      this.profile.first_name =
        this.activeUser.inbox_user && this.activeUser.inbox_user != null
          ? this.activeUser.inbox_user.first_name
          : "";
      this.profile.last_name =
        this.activeUser.inbox_user && this.activeUser.inbox_user != null
          ? this.activeUser.inbox_user.last_name
          : "";
      this.profile.tags = [];
      this.activeUser.group_tags.map((item) => {
        this.profile.tags.push(
          this.tagsOptions.find((tagItem) => tagItem.value == item)
        );
      });
      this.activeUser.group_followers.map((item) => {
        if (item != this.user.user.id) {
          this.profile.mentionedUsers.push(
            this.mentionUsers.find((mention) => mention.id == item)
          );
        }
      });
    },
    // Method is used to handle update profile API
    async handleUpdateProfileSubmit(data, sendDataAs) {
      this.submittedProfile = true;
      // stop here if form is invalid
      // this.$v.profile.$touch();
      // if (this.$v.profile.$invalid) {
      // return;
      if (data.name == "" && sendDataAs == undefined) {
        this.showEmptyNameError = true;
        return;
      } else {
        let dataToSave = "";
        if (sendDataAs == "json") {
          dataToSave = {
            group_tags: data.tags.map((tag) => {
              return tag.value;
            }),
            group_followers: data.mentionedUsers.map((user) => {
              return user.id;
            }),
          };
        } else {
          const profileFormData = new FormData();
          profileFormData.append("group_name", data.name);
          if (this.profileAttachments !== null) {
            profileFormData.append("group_avtar", this.profileAttachments);
          }
          dataToSave = profileFormData;
        }
        const response = await InboxService.editInboxGroups(
          this.activeUser.id,
          dataToSave
        );
        if (response) {
          this.getRepeatedGuestGC();
          this.isUpdateProfileBtnLoading = false;
          this.submittedProfile = false;
          this.showEmptyNameError = false;
          this.activeUser = {
            ...this.activeUser,
            ...response,
          };
          // this.allChatData.map((item) => {
          //   if (item.id == this.activeUser.id) {
          //     item = response;
          //   }
          // });
          Middleware.notification("Successfully updated !!", "success");
          this.$bvModal.hide("update-profile");
        }
      }
      this.isUpdateProfileBtnLoading = false;
    },
    // Method is used to close update profile
    cancelUpdateProfileSubmit() {
      this.$bvModal.hide("update-profile");
      this.profile.tags = [];
      this.profile.name = null;
      this.profile.first_name = null;
      this.profile.last_name = null;
      this.showEmptyNameError = false;
      this.displayProfile = true;
    },
    // Method is used to close add inbox
    cancelAdding() {
      this.$bvModal.hide("add-chat");
      this.submittedLobbyChat = false;
    },
    // To send new message
    async formSubmit(e) {
      if (this.form.message == "" && this.attachments.length == 0) {
        return;
      } else {
        this.sendingMessage = true;
        const message = this.form.message;
        let messageData = new FormData();
        if (this.selectedMessage != null) {
          messageData.append("msg_reply", this.selectedMessage.id);
        }
        if (this.attachments.length != 0) {
          this.attachments.map((img) => {
            messageData.append("upload_media", img);
          });
        }
        messageData.append("msg_channel", this.smsType);
        messageData.append("msg_content", message);
        if (this.msgTagUsers.length != 0) {
          for (let index = 0; index < this.msgTagUsers.length; index++) {
            messageData.append(`tagged_by[${index}]`, this.msgTagUsers[index]);
          }
        }
        try {
          if (this.activeUser.personal) {
            let res = await InboxService.personalChatMessages(
              this.activeUser.id,
              messageData
            );
            if (res) {
              this.doScroll = true;
            }
          } else {
            let res = await InboxService.chatMessages(
              this.activeUser.id,
              messageData
            );
            if (res) {
              this.doScroll = true;
            }
          }
          this.sendingMessage = false;
          this.submitted = false;
          this.msgTagUsers = [];
          this.form = {};
          this.form.message = "";
          if (this.selectedMessage != null) {
            this.selectedMessage = null;
          }
          this.attachments = [];
          this.attachmentsToShow = [];
        } catch (error) {
          this.sendingMessage = false;
          errorHandler(error);
        }
      }
    },
    // to auto scroll to bottom
    handleScroll() {
      if (this.$refs.current !== undefined && this.$refs != undefined) {
        if (this.$refs.current.$el) {
          setTimeout(() => {
            this.$refs.current.SimpleBar.getScrollElement().scrollTop =
              this.$refs.current.SimpleBar.getScrollElement().scrollHeight +
              1500;
          }, 500);
        }
      }
    },
    // EXTRA METHODS (HELPERS)
    // Method use to convert date OR time in user specific format
    convertDateOrTime(dateTime, format) {
      if (format !== "fromNow") return moment(dateTime).format(format);
      else return moment(dateTime).fromNow();
    },
    checkUser() {
      this.users = [];
    },
    tagInMessage(user) {
      this.form.message = this.form.message.replace(this.matchUser, "");
      this.form.message += user.name;
      this.isShowAllUsers = false;
      this.matchUser = "";
    },
    // React using emoji
    async printMoji(emoji) {
      let reactData = new FormData();
      if (!this.activeUser.personal) {
        reactData.append("reaction", emoji);
      } else {
        reactData.append("msg_reaction", emoji);
      }

      if (!this.activeUser.personal) {
        try {
          const response = await InboxService.addReaction(
            this.reactionOnMessage,
            reactData
          );
          if (response) {
            this.getRepeatedData(this.activeUser);
          }
        } catch (error) {
          errorHandler(error);
        }
      } else {
        try {
          const response = await InboxService.addReactionPersonal(
            this.reactionOnMessage,
            reactData
          );
          if (response) {
            this.getRepeatedData(this.activeUser);
          }
        } catch (error) {
          errorHandler(error);
        }
      }
      this.showEmoji = !this.showEmoji;
    },
    showEmojiEvt(message_id) {
      this.reactionOnMessage = message_id;
      this.showEmoji = !this.showEmoji;
    },
    handleClick(event, item) {
      if (item.align !== "right") {
        this.optionsArray1 = [
          {
            name: "<i class='fas fa-reply me-2'></i>Reply",
            slug: "reply",
          },
          {
            name: "<i class='far fa-copy me-2'></i>Copy",
            slug: "copy",
          },
        ];
        if (this.activeUser.personal == undefined) {
          this.optionsArray1.push({
            name: "<i class='fas fa-glasses me-2'></i>Mark as Unread",
            slug: "read",
          });
        }
      } else {
        this.optionsArray1 = [
          {
            name: "<i class='fas fa-reply me-2'></i>Reply",
            slug: "reply",
          },
          {
            name: "<i class='far fa-copy me-2'></i>Copy",
            slug: "copy",
          },
        ];
      }
      this.$refs.vueSimpleContextMenu1.showMenu(event, item);
    },
    optionClicked(event) {
      if (event.option.slug == "reply") {
        this.$refs.msgInput.focus();
        this.selectedMessage = event.item.allData;
      }
      if (event.option.slug == "read") {
        if (event.item.align != "right") {
          try {
            InboxService.markAsUnread(event.item.allData.id);
            this.activeUser = null;
          } catch (error) {
            errorHandler(error);
          }
        }
      }
      if (event.option.slug == "copy") {
        var input = document.createElement("textarea");
        input.innerHTML = event.item.message;
        document.body.appendChild(input);
        input.select();
        var result = document.execCommand("copy");
        document.body.removeChild(input);
        Middleware.notification("Copied", "success");
        return result;
      }
    },
    // To get file for message
    getFile() {
      document.getElementById("getFile").click();
    },
    // * Image uploading
    attachment(event) {
      if (this.attachmentsToShow.length < 5) {
        const images = event.target.files;
        for (let index = 0; index < images.length; index++) {
          const image = images[index];
          if (this.attachments.length < 5) {
            this.attachments.push(image);
          }
          const reader = new FileReader();
          reader.readAsDataURL(image);
          reader.onload = (event) => {
            if (this.attachmentsToShow.length < 5) {
              this.attachmentsToShow.push(event.target.result);
            }
          };
        }
      } else {
        Middleware.notification(
          "You can upload five images at a time !!",
          "info"
        );
      }
    },
    profileAttachment(event) {
      this.profileAttachments = event[0] == undefined ? null : event[0];
    },
    removeAttachmentImg(index) {
      this.attachmentsToShow.splice(index, 1);
      this.attachments.splice(index, 1);
    },
    hide() {
      if (this.showEmoji !== false) {
        this.showEmoji = false;
      }
    },
    // Following methods are for tags
    addNewTag() {
      this.$bvModal.show("update-tags");
    },
    showAll(data) {
      this.activeUser = null;
      this.selectedName = data;
      if (data == "All") {
        this.allChatData = [...this.chatData, ...this.groupChatData];
        this.$root.$emit("chatData", this.allChatData);
        this.showingAll = true;
      } else if (data == "Inbox") {
        this.allChatData = this.chatData;
        this.$root.$emit("chatData", this.allChatData);
        this.showingAll = false;
      } else if (data == "Mentions") {
        this.allChatData = [];
        this.$root.$emit("chatData", this.allChatData);
      } else if (data == "Lobby") {
        let newChatData = [];
        this.mentionUsers.map((item) => {
          if (item.last_chat_message != null) {
            newChatData.push(item);
          }
        });
        this.allChatData = [...this.groupChatData, ...newChatData];
        this.$root.$emit("chatData", this.allChatData);
      } else if (data == "Personal") {
        this.allChatData = this.mentionUsers;
        this.$root.$emit("chatData", this.allChatData);
      } else if (data == "Following") {
        this.allChatData = [];
        for (let index = 0; index < this.chatData.length; index++) {
          if (
            this.chatData[index].group_followers.includes(this.user.user.id)
          ) {
            this.allChatData.push(this.chatData[index]);
          }
        }
        for (let index = 0; index < this.groupChatData.length; index++) {
          if (
            this.groupChatData[index].group_followers.includes(
              this.user.user.id
            )
          ) {
            this.allChatData.push(this.groupChatData[index]);
          }
        }
        this.$root.$emit("chatData", this.allChatData);
      }
    },
    openGroupChat(data) {
      let avail = false;
      this.chatData.map((item) => {
        if (item.id == data.id) {
          avail = false;
        } else {
          avail = true;
        }
      });
      if (avail) {
        this.chatData.push(data);
      }
    },
    setImageToPreview(images) {
      this.previewImageInModel = images;
    },
    addOrRemoveTag(data, index) {
      if (!this.activeUser.group_tags.includes(data)) {
        this.activeUser.group_tags.push(data);
      } else {
        this.activeUser.group_tags.splice(index, 1);
      }
    },
    findTags() {
      this.displayTags = [];
      this.activeUser.group_tags.map((item) => {
        this.displayTags.push(
          this.tagsOptions.find((tagItem) => tagItem.value == item)
        );
      });
    },
    async updateTags() {
      let tagUpdate = "";
      tagUpdate = {
        group_tags: this.displayTags.map((tag) => {
          return tag.value;
        }),
      };
      const response = await InboxService.editInboxGroups(
        this.activeUser.id,
        tagUpdate
      );
      if (response) {
        this.activeUser.group_tags = response.group_tags;
        Middleware.notification("Successfully updated !!", "success");
      }
    },
    async followGroup(data) {
      if (
        data.group_followers.length != 0 &&
        data.group_followers.includes(this.user.user.id)
      ) {
        try {
          const response = await InboxService.unfollowInboxGroup(data.id);
          if (response) {
            this.activeUser.group_followers = response.group_followers;
            Middleware.notification(
              "Removed from favorites !!",
              "success",
              1500
            );
          }
        } catch (error) {
          errorHandler(error);
        }
      } else {
        try {
          const response = await InboxService.followInboxGroup(data.id);
          if (response) {
            this.activeUser.group_followers = response.group_followers;
            Middleware.notification("Added to favorites !!", "success", 1500);
          }
        } catch (error) {
          errorHandler(error);
        }
      }
    },
  },
};
</script>

<template>
  <div
    v-if="
      user.user.message_app_setting.is_access_message_app &&
      this.hotel.is_bulk_vs_sms_enable
    "
  >
    <PageHeader :title="`${title} ( ${hotel.sms_number} )`" />
    <div class="card">
      <div class="p-3">
        <div class="row">
          <div class="col-xxl-2 col-lg-3">
            <div class="email-leftbar p-0 w-100 card mb-0">
              <b-button variant="danger" class="m-3" @click="newConvo(false)">
                Compose
              </b-button>
              <div class="menu-list">
                <div class="mx-3">
                  <div
                    class="mail-list"
                    v-for="option in sideBar"
                    :key="option.name"
                  >
                    <a
                      href="#"
                      v-if="
                        option.name == 'Inbox' &&
                        user.user.message_app_setting.is_view_guest_inbox_group
                      "
                      :class="{ active: selectedName == option.name }"
                      @click="showAll(option.name)"
                    >
                      <i :class="option.icon" class="me-2 fs-5"></i
                      >{{ option.name }}
                      <span
                        v-if="option.name == 'All'"
                        class="ms-1 float-end"
                        >{{ counter != 0 ? "(" + counter + ")" : "" }}</span
                      >
                    </a>
                    <a
                      href="#"
                      v-else
                      :class="{ active: selectedName == option.name }"
                      @click="showAll(option.name)"
                    >
                      <i :class="option.icon" class="me-2 fs-5"></i
                      >{{ option.name }}
                      <span
                        v-if="option.name == 'All'"
                        class="ms-1 float-end"
                        >{{ counter != 0 ? "(" + counter + ")" : "" }}</span
                      >
                    </a>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-between mt-4 col-md-12"
                  >
                    <h6 class="cursor col-md-11" @click="showAll('Lobby')">
                      Lobby
                    </h6>
                    <i
                      v-if="
                        user.user.message_app_setting.is_edit_lobby_inbox_group
                      "
                      @click="newConvo(true)"
                      class="bx bx-plus p-1 text-end bg-primary text-white rounded col-md-1"
                    ></i>
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between mt-4"
                  >
                    <h6>Tags</h6>
                    <i
                      v-if="
                        user.user.message_app_setting.is_edit_group_tag_setting
                      "
                      @click="addNewTag()"
                      class="bx bx-plus p-1 text-end bg-primary text-white rounded"
                    ></i>
                  </div>
                  <TagManager
                    :tagOptionsAvail="tagsOptions"
                    @updateTags="getTags()"
                  />
                  <h6 class="mt-4">Shared Inboxes</h6>
                  <div class="mail-list">
                    <router-link to="">
                      support@macrotech.net
                      <span class="ms-1 float-end"></span>
                    </router-link>
                    <router-link to="">
                      sales@macrotech.net
                      <span class="ms-1 float-end"></span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xxl-10 col-lg-9">
            <div class="row" :class="isDisplayChat ? '' : 'd-none'">
              <div class="col-xxl-3">
                <div class="chat-leftsidebar">
                  <div class="chat-leftsidebar-nav">
                    <div
                      class="d-flex align-items-center justify-content-between mb-2"
                    >
                      <h5 class="font-size-14">Contacts / Conversations</h5>
                      <i
                        class="mdi mdi-arrow-left fs-4 back-arrow"
                        @click="
                          () => {
                            this.isDisplayChat = false;
                            activeUser = null;
                          }
                        "
                      ></i>
                    </div>

                    <simplebar id="chat-list">
                      <ul
                        class="list-unstyled chat-list"
                        v-for="(data, index) of allChatData"
                        :key="index"
                      >
                        <li
                          @click="chatUsername(data)"
                          :class="{
                            active:
                              activeUser != null && activeUser.id == data.id,
                          }"
                          v-if="data"
                        >
                          <a href="javascript: void(0);">
                            <div class="d-flex">
                              <div
                                class="position-relative me-3"
                                v-if="data.image"
                              >
                                <img
                                  :src="data.image"
                                  class="rounded-circle picture-img"
                                  alt="profile-photo"
                                />
                                <div
                                  class="profile-status-icon"
                                  v-if="data.personal"
                                >
                                  <i
                                    class="mdi mdi-circle align-middle me-1"
                                    :class="
                                      data.status && data.status == 'online'
                                        ? 'text-success'
                                        : 'text-danger'
                                    "
                                  ></i>
                                </div>
                              </div>
                              <div
                                class="align-self-center me-3"
                                v-else-if="data.group_avtar"
                              >
                                <img
                                  :src="data.group_avtar"
                                  class="rounded-circle picture-img"
                                  alt="profile-photo"
                                />
                              </div>
                              <div
                                v-else
                                class="picture-img align-self-center me-3"
                              >
                                <span
                                  class="avatar-title rounded-circle bg-soft bg-primary text-primary text-capitalize"
                                  >{{
                                    data.name ? data.name.charAt(0) : "c"
                                  }}</span
                                >
                              </div>
                              <div class="vac-name-container vac-text-ellipsis">
                                <div class="d-flex justify-content-between">
                                  <h5 class="text-truncate font-size-14 mb-1">
                                    {{ data.name }}
                                  </h5>
                                  <div
                                    class="font-size-11"
                                    v-if="data.last_inbox_message !== null"
                                  >
                                    {{
                                      convertDateOrTime(
                                        data.last_inbox_message.created_at,
                                        "fromNow"
                                      )
                                    }}
                                  </div>
                                </div>
                                <div
                                  class="overflow-hidden"
                                  v-if="data.last_inbox_message !== null"
                                >
                                  <div class="d-flex align-items-center">
                                    <p
                                      v-if="
                                        data.last_inbox_message.msg_content !==
                                        ''
                                      "
                                      class="text-truncate mb-0"
                                      :class="
                                        data.unread_message != 0
                                          ? 'fw-bold'
                                          : ''
                                      "
                                    >
                                      {{ data.last_inbox_message.msg_content }}
                                    </p>
                                    <span
                                      v-else-if="
                                        data.last_inbox_message.msg_media_urls
                                          .length != 0
                                      "
                                      class="text-truncate"
                                      :class="
                                        data.unread_message != 0
                                          ? 'fw-bold'
                                          : ''
                                      "
                                    >
                                      <i class="far fa-image"></i>
                                      {{ "Photo" }}
                                    </span>
                                    <span class="d-block ms-auto me-1">
                                      {{
                                        data.unread_message != 0
                                          ? "(" + data.unread_message + ")"
                                          : ""
                                      }}
                                    </span>
                                    <template>
                                      <i
                                        v-if="
                                          data.last_inbox_message.msg_channel ==
                                          'sms'
                                        "
                                        class="mdi mdi-message-processing-outline text-primary fs-5"
                                      ></i>
                                      <i
                                        v-if="
                                          data.last_inbox_message.msg_channel ==
                                          'chat'
                                        "
                                        class="bx bx-chat text-danger fs-5"
                                      ></i>
                                      <!-- <i
                                        v-if="
                                          data.last_inbox_message.msg_channel ==
                                          undefined
                                        "
                                        class="fas fa-people-arrows text-warning fs-6 me-2"
                                      ></i> -->
                                    </template>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </simplebar>
                  </div>
                </div>
              </div>
              <div class="col-xxl-9" v-if="activeUser !== null">
                <div class="chat-right-side d-flex">
                  <div :class="isShowGuestDetails ? 'w-80' : 'w-95'">
                    <div class="w-100 user-chat position-relative">
                      <div class="card mb-0">
                        <div class="p-3 border-bottom">
                          <div class="row">
                            <div class="col-md-6 col-8">
                              <div class="d-flex align-items-center">
                                <div
                                  v-if="
                                    (activeUser.group_type == 'common_lobby' &&
                                      user.user.message_app_setting
                                        .is_edit_lobby_inbox_group) ||
                                    (activeUser.group_type == 'guest' &&
                                      user.user.message_app_setting
                                        .is_edit_guest_inbox_group) ||
                                    !activeUser.personal
                                  "
                                >
                                  <img
                                    @click="updateProfile"
                                    class="rounded-circle picture-img cursor"
                                    v-if="activeUser.group_avtar"
                                    :src="activeUser.group_avtar"
                                  />
                                  <img
                                    v-else-if="
                                      activeUser.inbox_user &&
                                      activeUser.inbox_user.profile_picture
                                    "
                                    :src="activeUser.inbox_user.profile_picture"
                                    class="rounded-circle picture-img me-3"
                                    alt="profile-photo"
                                  />
                                  <img
                                    @click="updateProfile"
                                    class="rounded-circle picture-img cursor"
                                    v-else-if="activeUser.profile_picture"
                                    :src="activeUser.profile_picture"
                                  />
                                  <div
                                    @click="updateProfile"
                                    class="picture-img cursor"
                                    v-else
                                  >
                                    <span
                                      class="avatar-title rounded-circle bg-soft bg-primary text-primary text-capitalize"
                                    >
                                      {{
                                        activeUser.name
                                          ? activeUser.name.charAt(0)
                                          : "c"
                                      }}
                                    </span>
                                  </div>
                                </div>
                                <div v-else>
                                  <img
                                    class="rounded-circle picture-img cursor"
                                    v-if="activeUser.group_avtar"
                                    :src="activeUser.group_avtar"
                                  />
                                  <img
                                    class="rounded-circle picture-img cursor"
                                    v-else-if="activeUser.profile_picture"
                                    :src="activeUser.profile_picture"
                                  />
                                  <div class="picture-img cursor" v-else>
                                    <span
                                      class="avatar-title rounded-circle bg-soft bg-primary text-primary text-capitalize"
                                    >
                                      {{
                                        activeUser.name
                                          ? activeUser.name.charAt(0)
                                          : "c"
                                      }}
                                    </span>
                                  </div>
                                </div>
                                <div class="ms-2">
                                  <h5
                                    class="font-size-15 mb-1 text-truncate header-img-thumbnail cursor"
                                    v-b-popover.hover.bottom="activeUser.name"
                                  >
                                    {{ activeUser.name }}
                                  </h5>
                                  <p
                                    class="text-muted mb-0"
                                    v-if="activeUser.personal"
                                  >
                                    <i
                                      class="mdi mdi-circle align-middle me-1"
                                      :class="
                                        activeUser.status &&
                                        activeUser.status == 'online'
                                          ? 'text-success'
                                          : 'text-danger'
                                      "
                                    ></i>
                                    {{
                                      activeUser.status &&
                                      activeUser.status == "online"
                                        ? "Active now"
                                        : "Offline"
                                    }}
                                  </p>
                                </div>
                                <div
                                  class="ms-3 d-flex align-items-center flex-wrap"
                                >
                                  <template
                                    v-if="activeUser && activeUser.group_tags"
                                  >
                                    <div
                                      v-for="(tags, index) in tagsOptions"
                                      :key="index"
                                    >
                                      <div
                                        v-for="tag in activeUser.group_tags"
                                        :key="tag"
                                      >
                                        <div v-if="tags.value == tag">
                                          <button
                                            class="btn btn-sm rounded me-1"
                                            :style="{
                                              color: [tags.color],
                                              'border-color': [tags.color],
                                            }"
                                          >
                                            {{ tags.name }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-md-6 col-4"
                              v-if="!activeUser.personal"
                            >
                              <ul
                                class="list-inline user-chat-nav text-end mb-0 d-flex align-items-center justify-content-end"
                              >
                                <li
                                  class="list-inline-item d-none d-sm-inline-block"
                                >
                                  <div
                                    menu-class="dropdown-menu-end"
                                    right
                                    variant="white"
                                  >
                                    <template>
                                      <div class="card rounded-pill p-1 mb-0">
                                        <div
                                          class="d-flex align-items-center"
                                          @click="updateProfile"
                                        >
                                          <div
                                            class="avatar-xs align-self-center me-2"
                                          >
                                            <span
                                              class="avatar-title rounded-circle bg-soft bg-primary text-primary"
                                              >{{
                                                profile.mentionedUsers.length !=
                                                0
                                                  ? profile.mentionedUsers[0].name.charAt(
                                                      0
                                                    )
                                                  : "U"
                                              }}
                                            </span>
                                          </div>
                                          <p
                                            class="mb-0 me-1 text-truncate header-img-thumbnail"
                                          >
                                            {{
                                              profile.mentionedUsers.length != 0
                                                ? profile.mentionedUsers[0].name
                                                : "Unassigned"
                                            }}
                                          </p>
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                </li>
                                <li
                                  class="list-inline-item d-none d-sm-inline-block"
                                >
                                  <i
                                    class="mdi mdi-check fs-4"
                                    v-b-popover.hover.bottom="
                                      'Mark as a closed'
                                    "
                                  ></i>
                                </li>
                                <li
                                  class="list-inline-item d-none d-sm-inline-block"
                                >
                                  <i
                                    class="mdi mdi-email-outline fs-4"
                                    v-b-popover.hover.bottom="
                                      'Mark as a unread'
                                    "
                                  ></i>
                                </li>
                                <li
                                  class="list-inline-item d-none d-sm-inline-block"
                                >
                                  <i
                                    class="mdi mdi-clock-outline fs-4"
                                    v-b-popover.hover.bottom="'Snooze'"
                                  ></i>
                                </li>
                                <li
                                  class="list-inline-item d-none d-sm-inline-block"
                                >
                                  <i
                                    class="mdi mdi-alert-octagon-outline fs-4"
                                    v-b-popover.hover.bottom="'Report spam'"
                                  ></i>
                                </li>
                                <li
                                  class="list-inline-item d-none d-sm-inline-block"
                                >
                                  <i
                                    class="fas fa-star fs-5"
                                    :class="{
                                      'text-warning':
                                        activeUser.group_followers.includes(
                                          user.user.id
                                        ),
                                    }"
                                    v-b-popover.hover.bottom="'Favourite'"
                                    @click="followGroup(activeUser)"
                                  ></i>
                                </li>
                                <li
                                  class="list-inline-item d-none d-sm-inline-block"
                                >
                                  <b-dropdown
                                    menu-class="dropdown-menu-lg dropdown-menu-end p-0"
                                    variant="white"
                                    right
                                    toggle-class="p-0"
                                  >
                                    <template v-slot:button-content>
                                      <i
                                        @click="findTags()"
                                        class="mdi mdi-tag-outline fs-4"
                                        v-b-popover.hover.bottom="'Tag'"
                                      ></i>
                                    </template>
                                    <div class="p-3">
                                      <form class="mb-2">
                                        <div class="form-group m-0">
                                          <div class="input-group">
                                            <MultiSelect
                                              class="my-1"
                                              v-model="displayTags"
                                              :options="tagsOptions"
                                              placeholder="Select/Add tag"
                                              label="name"
                                              track-by="value"
                                              :show-labels="false"
                                              :multiple="true"
                                            ></MultiSelect>
                                          </div>
                                          <b-button
                                            class="float-end ms-2 mt-1"
                                            variant="outline-primary"
                                            @click="updateTags()"
                                          >
                                            Update
                                          </b-button>
                                        </div>
                                      </form>
                                      <label>Edit Tags</label>

                                      <div class="d-flex py-1 px-2">
                                        <i class="mdi mdi-tag-outline fs-4"></i>
                                        <p class="ms-2 mb-0">New Tag</p>
                                      </div>
                                      <div class="d-flex py-1 px-2">
                                        <i
                                          class="dripicons-tag-delete fs-4"
                                        ></i>
                                        <p class="ms-2 mb-0">Clear Tags</p>
                                      </div>
                                    </div>
                                  </b-dropdown>
                                </li>
                                <li
                                  class="list-inline-item d-none d-sm-inline-block"
                                >
                                  <i
                                    class="mdi mdi-delete-outline fs-4"
                                    v-b-popover.hover.bottom="'Delete'"
                                  ></i>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="position-relative">
                          <div class="chat-users">
                            <div class="chat-conversation p-3">
                              <simplebar
                                :class="[
                                  selectedMessage != null &&
                                  selectedMessage.msg_media_urls.length == 0 &&
                                  attachmentsToShow.length == 0
                                    ? 'container-element-replay-height'
                                    : attachmentsToShow.length != 0 &&
                                      selectedMessage == null
                                    ? 'container-element-image-height'
                                    : selectedMessage != null &&
                                      selectedMessage.msg_media_urls.length ==
                                        0 &&
                                      attachmentsToShow.length != 0
                                    ? 'container-element-both-height'
                                    : selectedMessage != null &&
                                      selectedMessage.msg_media_urls.length !=
                                        0 &&
                                      attachmentsToShow.length == 0
                                    ? 'container-element-reply-image-height'
                                    : selectedMessage != null &&
                                      selectedMessage.msg_media_urls.length !=
                                        0 &&
                                      attachmentsToShow.length != 0
                                    ? 'container-element-reply-image-double-height'
                                    : 'container-element-height',
                                ]"
                                id="containerElement"
                                ref="current"
                              >
                                <div v-if="gettingMessages" id="status">
                                  <div class="spinner-chase">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                                <ul v-else class="list-unstyled">
                                  <li
                                    v-for="(data, index) in chatMessagesData"
                                    :key="index"
                                    :class="[
                                      { right: `${data.align}` === 'right' },
                                    ]"
                                  >
                                    <div
                                      v-if="
                                        chatMessagesData[index - 1] ==
                                          undefined ||
                                        convertDateOrTime(
                                          chatMessagesData[index].allData
                                            .created_at,
                                          'DD MMM YYYY'
                                        ) !=
                                          convertDateOrTime(
                                            chatMessagesData[index - 1].allData
                                              .created_at,
                                            'DD MMM YYYY'
                                          )
                                      "
                                    >
                                      <div class="chat-day-title">
                                        <span class="title">{{
                                          convertDateOrTime(
                                            chatMessagesData[index].allData
                                              .created_at,
                                            "DD MMM YYYY"
                                          )
                                        }}</span>
                                      </div>
                                    </div>
                                    <div class="conversation-list w-75">
                                      <div class="d-flex">
                                        <div
                                          @contextmenu.prevent.stop="
                                            handleClick($event, data)
                                          "
                                          class="ctext-wrap"
                                          :class="[
                                            data.align == 'right'
                                              ? 'd-block ms-auto text-start'
                                              : '',
                                            data.allData.msg_channel == 'chat'
                                              ? 'bg-warning bg-soft'
                                              : '',
                                          ]"
                                        >
                                          <div
                                            class="conversation-name"
                                            v-if="
                                              data.allData &&
                                              data.allData.msg_sent_by &&
                                              data.allData.msg_sent_by
                                                .first_name
                                            "
                                          >
                                            {{
                                              data.allData.msg_sent_by
                                                .first_name
                                            }}
                                            {{
                                              data.allData.msg_sent_by.id ==
                                              user.user.id
                                                ? "(You)"
                                                : ""
                                            }}
                                          </div>
                                          <div
                                            class="bg-secondary bg-soft rounded p-2"
                                            v-if="
                                              data.allData.msg_reply != null
                                            "
                                          >
                                            <p class="mb-0">
                                              <template
                                                v-if="
                                                  data.allData.msg_reply
                                                    .msg_media_urls.length !== 0
                                                "
                                              >
                                                <img
                                                  v-for="(image, index) in data
                                                    .allData.msg_reply
                                                    .msg_media_urls"
                                                  class="bg-secondary bg-soft rounded p-1 attachment-replay-img object-fit m-1"
                                                  :key="index"
                                                  :src="image"
                                                />
                                              </template>
                                            </p>
                                            {{
                                              data.allData.msg_reply.msg_content
                                            }}
                                          </div>
                                          <div
                                            v-if="
                                              data.allData.msg_media_urls
                                                .length !== 0
                                            "
                                          >
                                            <img
                                              v-b-modal.image-preview
                                              v-for="(image, index) in data
                                                .allData.msg_media_urls"
                                              class="bg-secondary bg-soft rounded p-2 attachment-picture-img object-fit m-1"
                                              :key="index"
                                              :src="
                                                image.replace(
                                                  'upload',
                                                  'thumbs200'
                                                )
                                              "
                                              @click="
                                                setImageToPreview(
                                                  data.allData.msg_media_urls
                                                )
                                              "
                                            />
                                          </div>
                                          <p class="mb-0">
                                            {{ data.message }}
                                          </p>
                                          <p class="chat-time mb-0 text-end">
                                            <i
                                              v-if="
                                                data.allData.msg_channel ==
                                                'sms'
                                              "
                                              class="mdi mdi-message-processing-outline text-primary fs-6"
                                            ></i>
                                            <i
                                              v-if="
                                                data.allData.msg_channel ==
                                                'chat'
                                              "
                                              class="bx bx-chat text-danger fs-6"
                                            ></i>
                                            <!-- <i
                                              v-if="
                                                data.allData.msg_channel ==
                                                undefined
                                              "
                                              class="fas fa-people-arrows text-warning fs-8"
                                            ></i> -->
                                            <span
                                              v-if="
                                                activeUser.personal &&
                                                data.allData.read_at !== null &&
                                                data.align == 'right'
                                              "
                                              class="fs-8"
                                            >
                                              <i
                                                class="fas fa-check-double text-dark"
                                              ></i>
                                            </span>
                                            <span
                                              v-if="
                                                activeUser.personal &&
                                                data.allData.read_at == null &&
                                                data.align == 'right'
                                              "
                                              class="fs-8"
                                            >
                                              <i
                                                class="fas fa-check text-dark"
                                              ></i>
                                            </span>
                                            {{ data.time }}
                                          </p>
                                        </div>
                                        <div
                                          class="position-relative"
                                          v-if="data.align !== 'right'"
                                          @blur="hide()"
                                        >
                                          <div
                                            class="fs-5"
                                            @click="
                                              showEmojiEvt(data.allData.id)
                                            "
                                          >
                                            <i class="far fa-smile ms-2"></i>
                                          </div>
                                          <ul
                                            :class="
                                              showEmoji &&
                                              reactionOnMessage ==
                                                data.allData.id
                                                ? 'ms-0 emoji-icon emoji-icon-1'
                                                : 'ms-0 emoji-icon'
                                            "
                                          >
                                            <li
                                              class="fs-4 mx-1"
                                              v-for="emoji in emojis"
                                              :key="emoji"
                                            >
                                              <span @click="printMoji(emoji)">
                                                {{ emoji }}</span
                                              >
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div
                                        class="d-flex"
                                        :class="
                                          data.align == 'right'
                                            ? 'justify-content-end'
                                            : ''
                                        "
                                        v-if="
                                          data.reactions != null &&
                                          !data.personal
                                        "
                                      >
                                        <template
                                          v-for="react in data.reactions"
                                          ><div
                                            class="emoji-icons cursor"
                                            :key="react.id"
                                            v-if="react.reaction !== ''"
                                          >
                                            <span class="fs-5">
                                              {{ react.reaction }}
                                            </span>
                                          </div>
                                        </template>
                                      </div>
                                      <div
                                        v-else
                                        class="d-flex"
                                        :class="
                                          data.align == 'right'
                                            ? 'justify-content-end'
                                            : ''
                                        "
                                      >
                                        <div
                                          class="emoji-icons cursor"
                                          v-if="
                                            data.allData.msg_reaction !== ''
                                          "
                                        >
                                          <span class="fs-5">
                                            {{ data.allData.msg_reaction }}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </simplebar>
                              <div v-if="isShowAllUsers" class="z-index-n1">
                                <ul
                                  v-for="(user, index) in tagUsers"
                                  :key="index"
                                >
                                  <li @click="tagInMessage(user)">
                                    {{ user.name }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="p-3 chat-input-section">
                            <form
                              :disabled="sendingMessage"
                              v-if="
                                (activeUser.group_type == 'common_lobby' &&
                                  user.user.message_app_setting
                                    .is_sent_lobby_inbox_message) ||
                                (activeUser.group_type == 'guest' &&
                                  user.user.message_app_setting
                                    .is_sent_guest_inbox_message) ||
                                activeUser.personal
                              "
                              @submit.prevent="formSubmit"
                            >
                              <div
                                class="d-flex align-items-center mb-2"
                                v-if="selectedMessage != null"
                              >
                                <div class="vac-reply-box">
                                  <div class="bg-secondary bg-soft p-2 rounded">
                                    <h6
                                      class="font-size-15 text-primary mb-1"
                                      v-if="
                                        selectedMessage &&
                                        selectedMessage.msg_sent_by &&
                                        selectedMessage.msg_sent_by.first_name
                                      "
                                    >
                                      {{
                                        selectedMessage.msg_sent_by.first_name
                                      }}
                                    </h6>
                                    <p class="mb-0 text-truncate">
                                      {{ selectedMessage.msg_content }}
                                      <template
                                        v-if="
                                          selectedMessage.msg_media_urls
                                            .length !== 0
                                        "
                                      >
                                        <img
                                          v-for="(
                                            image, index
                                          ) in selectedMessage.msg_media_urls"
                                          class="bg-secondary bg-soft rounded p-2 attachment-picture-img object-fit m-1"
                                          :key="index"
                                          :src="image"
                                        />
                                      </template>
                                    </p>
                                  </div>
                                </div>

                                <div class="vac-icon-reply">
                                  <i
                                    class="mdi mdi-close fs-3 float-end"
                                    @click="selectedMessage = null"
                                  />
                                </div>
                              </div>
                              <div
                                class="vac-files-box d-flex mb-2"
                                v-if="attachmentsToShow.length != 0"
                                :disabled="sendingMessage"
                              >
                                <div
                                  class="me-2"
                                  v-for="(img, index) in attachmentsToShow"
                                  :key="index"
                                >
                                  <div
                                    class="vac-icon-remove position-relative"
                                  >
                                    <img
                                      :src="img"
                                      alt=""
                                      class="attachment-picture-img object-fit"
                                    />
                                    <div
                                      :disabled="sendingMessage"
                                      class="vac-border-button"
                                      @click="removeAttachmentImg(index)"
                                    >
                                      <i class="mdi mdi-close"></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="card mb-0"
                                :class="
                                  smsType == 'sms'
                                    ? ''
                                    : 'bg-warning border-warning bg-soft'
                                "
                              >
                                <div class="p-2">
                                  <div class="col">
                                    <div class="position-relative">
                                      <b-tabs
                                        :disabled="sendingMessage"
                                        class="w-25"
                                        justified
                                        nav-class="nav-tabs-custom"
                                        content-class="text-muted"
                                      >
                                        <b-tab
                                          v-if="
                                            activeUser.group_send_number != null
                                          "
                                          :active="smsType == 'sms'"
                                          @click="
                                            smsType = 'sms';
                                            textAreaMax = '250';
                                          "
                                        >
                                          <template v-slot:title>
                                            <span
                                              class="d-inline-block d-sm-none"
                                            >
                                              <i class="far fa-user"></i>
                                            </span>
                                            <span
                                              class="d-none d-sm-inline-block"
                                              >SMS</span
                                            >
                                          </template>
                                        </b-tab>
                                        <b-tab
                                          :active="smsType == 'chat'"
                                          @click="
                                            smsType = 'chat';
                                            textAreaMax = '2500';
                                          "
                                        >
                                          <template v-slot:title>
                                            <span
                                              class="d-inline-block d-sm-none"
                                            >
                                              <i class="fas fa-home"></i>
                                            </span>
                                            <span
                                              class="d-none d-sm-inline-block"
                                              >Note</span
                                            >
                                          </template>
                                        </b-tab>
                                      </b-tabs>
                                      <Mentionable
                                        :disabled="sendingMessage"
                                        v-if="smsType == 'chat'"
                                        placement="bottom"
                                        :keys="['@']"
                                        :items="mentionUsers"
                                        offset="6"
                                        insert-space
                                        @apply="applyMen($event)"
                                      >
                                        <textarea
                                          :disabled="sendingMessage"
                                          ref="msgInput"
                                          v-model="form.message"
                                          class="form-control border-0 form-textarea"
                                          name="textarea"
                                          rows="2"
                                          maxlength="250"
                                          placeholder="Type your message here... You can also use @ to mention a user (Note)"
                                          :class="[
                                            smsType == 'sms'
                                              ? ''
                                              : 'bg-transparent',
                                          ]"
                                        ></textarea>
                                      </Mentionable>
                                      <textarea
                                        v-else
                                        :disabled="sendingMessage"
                                        @keydown.enter="formSubmit()"
                                        ref="msgInput"
                                        v-model="form.message"
                                        class="form-control border-0 form-textarea"
                                        name="textarea"
                                        rows="2"
                                        maxlength="250"
                                        placeholder="Type your sms here..."
                                      ></textarea>
                                    </div>
                                  </div>
                                  <div
                                    class="col-auto d-flex align-items-end justify-content-between"
                                  >
                                    <div>
                                      <!-- <i class="fas fa-bold me-3 fs-5"></i>
                                      <i class="fas fa-underline me-3 fs-5"></i>
                                      <i class="fas fa-italic me-3 fs-5"></i>
                                      <i class="far fa-bookmark me-3 fs-5"></i> -->
                                      <i
                                        class="mdi mdi-paperclip fs-4"
                                        @click="getFile()"
                                      ></i>
                                      <input
                                        class="d-none"
                                        type="file"
                                        id="getFile"
                                        multiple
                                        @change="attachment($event)"
                                      />
                                    </div>
                                    <button
                                      type="submit"
                                      :disabled="sendingMessage"
                                      class="btn btn-primary btn-rounded chat-send w-md float-end"
                                    >
                                      <span
                                        class="d-none d-sm-inline-block me-2"
                                      >
                                        Send
                                      </span>
                                      <i
                                        v-if="!sendingMessage"
                                        class="mdi mdi-send"
                                      ></i>
                                      <i
                                        v-if="sendingMessage"
                                        class="fas fa-circle-notch bx-spin"
                                      ></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <smsGuestProfile
                    :userData="activeUser"
                    v-if="
                      !activeUser.personal &&
                      activeUser.group_type != 'common_lobby'
                    "
                    :class="isShowGuestDetails ? 'w-20' : 'w-5'"
                  />
                </div>
              </div>
              <div class="col-xxl-9" v-else>
                <div class="card mb-0">
                  <div class="card-body">
                    <img
                      src="@/assets/images/empty-chat.png"
                      alt="empty-chat"
                      class="empty-img d-block mx-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Last Message -->
            <Email v-show="!isDisplayChat" :currentProps="emailProps" />
          </div>
        </div>
      </div>
    </div>
    <!-- Model is to update group profile -->
    <b-modal
      id="update-profile"
      centered
      title="Update Profile"
      hide-footer
      title-class="font-18"
      @hidden="cancelUpdateProfileSubmit"
    >
      <b-tabs
        justified
        nav-class="nav-tabs-custom"
        content-class="pt-3 text-muted"
      >
        <b-tab active>
          <template v-slot:title>
            <span class="d-none d-sm-inline-block">Update Profile</span>
          </template>
          <form ref="form">
            <b-form-group class="mb-3">
              <label for="group_name"
                >Name <span class="text-danger">*</span></label
              >
              <b-form-input
                id="name-input"
                @change="
                  () => {
                    if (profile.name != '') {
                      showEmptyNameError = false;
                    }
                  }
                "
                v-model.trim="profile.name"
                placeholder="Enter your group name"
                autocomplete="off"
                type="text"
                :class="{
                  'is-invalid': showEmptyNameError,
                }"
              />
              <div v-if="showEmptyNameError" class="invalid-feedback">
                <span v-if="showEmptyNameError">Name can't be empty.</span>
              </div>
            </b-form-group>
            <div class="col-md-12">
              <div class="mb-3">
                <label for="">Profile Photo</label>
                <div
                  class="vac-icon-remove position-relative"
                  v-if="activeUser && displayProfile && activeUser.group_avtar"
                >
                  <div
                    class="vac-border-button"
                    @click="displayProfile = false"
                  >
                    <i class="mdi mdi-close"></i>
                  </div>
                  <img
                    :src="activeUser.group_avtar"
                    alt="profile-photo"
                    class="profile-photo rounded"
                  />
                </div>
                <VueDropify
                  v-else
                  @upload="profileAttachment($event)"
                  :src="imgURL"
                  message="Drop image here or click to select"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12">
                <b-button
                  class="float-end ms-2"
                  variant="outline-primary"
                  type="reset"
                  @click="cancelUpdateProfileSubmit"
                  >Cancel
                </b-button>
                <b-button
                  class="float-end ms-2"
                  variant="outline-primary"
                  @click="handleUpdateProfileSubmit(profile)"
                  :class="{ disabled: isUpdateProfileBtnLoading }"
                >
                  <i
                    v-if="isUpdateProfileBtnLoading"
                    class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                  ></i>
                  Update
                </b-button>
              </div>
            </div>
          </form>
        </b-tab>
        <b-tab
          ><template v-slot:title>
            <span class="d-none d-sm-inline-block">Update Info</span>
          </template>
          <label>ADD/REMOVE TAGS</label>
          <MultiSelect
            class="my-1"
            v-model="profile.tags"
            :options="tagsOptions"
            placeholder="Select/Add tag"
            label="name"
            track-by="value"
            :show-labels="false"
            :multiple="true"
          ></MultiSelect>
          <label class="mt-1">Add/REMOVE followers</label>
          <MultiSelect
            class="my-1"
            v-model="profile.mentionedUsers"
            :options="mentionUsers"
            placeholder="Select/Add tag"
            label="first_name"
            track-by="id"
            :show-labels="false"
            :multiple="true"
          ></MultiSelect>
          <b-button
            class="float-end ms-2 mt-1"
            variant="outline-primary"
            type="reset"
            @click="cancelUpdateProfileSubmit"
            >Cancel
          </b-button>
          <b-button
            class="float-end ms-2 mt-1"
            variant="outline-primary"
            @click="handleUpdateProfileSubmit(profile, 'json')"
            :class="{ disabled: isUpdateProfileBtnLoading }"
          >
            <i
              v-if="isUpdateProfileBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            Update
          </b-button>
        </b-tab>
      </b-tabs>
    </b-modal>
    <!-- Model is for add chat -->
    <b-modal
      id="add-chat"
      centered
      :title="!isLobbyGroup ? 'Compose New Message' : 'Create Lobby Group'"
      hide-footer
      title-class="font-18"
      @hidden="cancelAdding"
    >
      <form ref="form" v-if="!isLobbyGroup">
        <GuestRegister />
      </form>
      <div v-if="isLobbyGroup">
        <LobbyRegister />
      </div>
    </b-modal>
    <!-- preview image modal -->
    <b-modal
      id="image-preview"
      centered
      hide-header
      hide-header-close
      hide-footer
      size="lg"
      ><div v-if="previewImageInModel.length !== 0">
        <b-carousel
          no-animation
          :controls="previewImageInModel.length > 1 ? true : false"
        >
          <b-carousel-slide
            :img-src="image"
            v-for="(image, index) in previewImageInModel"
            :key="index"
            class="w-100"
          ></b-carousel-slide>
        </b-carousel></div
    ></b-modal>
    <!-- Right click to show menu -->
    <vue-simple-context-menu
      v-if="user.user.message_app_setting.is_sent_guest_inbox_message"
      element-id="myFirstMenu"
      :options="optionsArray1"
      ref="vueSimpleContextMenu1"
      @option-clicked="optionClicked"
    ></vue-simple-context-menu>
  </div>
  <div v-else>
    <PageHeader :title="`${title}`" />
    <div class="card">
      <div class="p-3">
        <div class="row">
          <h2>Messaging Service Unavailable!</h2>
        </div>
      </div>
    </div>
  </div>
</template>
